import type { Feature, FeatureModule } from '../../../types';
import { featureList } from '../../helpers';
import { RESOURCES_FEATURE_GROUP } from './group';

export const RESOURCES_FEATURES = {
  READ: {
    guid: 'a3d6ec67-9f51-4f12-c345-0a2f3f4d0000',
    name: 'resources:read',
    description: 'View resources, documentation, and support links',
    action: 'read',
    product: 'account',
    parentGuid: RESOURCES_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export { RESOURCES_FEATURE_GROUP } from './group';

export const RESOURCES_MODULE: FeatureModule = {
  product: 'account',
  groups: [RESOURCES_FEATURE_GROUP],
  features: featureList(RESOURCES_FEATURES),
};
